import React, { useEffect, useRef, useState } from "react";
import CartHeaderButton from "../cart-header-button/CartHeaderButton";
import './MahutiHeader.css'
import { isMobile } from "react-device-detect";
import { useNavigate } from "react-router-dom";
import { PREFIX_PATH } from "../../utils/GlobalParams";
import { useDispatch, useSelector } from "react-redux";
import { clearAll } from "../../utils/orderUtils";
import MahutiContrastToggler from "../mahutiContrastToggle/MahutiContrastToggler";

export default function MahutiHeader({contrastTogglerRef}) {

    const menuRef = useRef(null);
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const store = useSelector(store => store.reducer);
    let lpPrefix = store.lpName ? '/' + store.lpName : '';
    // Add state to track viewport width
    const [isNarrowViewport, setIsNarrowViewport] = useState(false);

    // Add effect to handle viewport changes
    useEffect(() => {
        const checkViewport = () => {
            // 992px is Bootstrap's lg breakpoint
            setIsNarrowViewport(window.innerWidth < 992);
        };

        // Check initial viewport
        checkViewport();

        // Add event listener for resize
        window.addEventListener('resize', checkViewport);

        // Cleanup
        return () => window.removeEventListener('resize', checkViewport);
    }, []);

    useEffect(() => {
        const handleFocusOut = (event) => {
            // בודק אם האלמנט החדש שקיבל פוקוס נמצא מחוץ לתפריט
            if (menuRef.current && !menuRef.current.contains(event.relatedTarget)) {
                // סגירת התפריט
                const navbarCollapse = document.getElementById('mahutiLinks');
                if (navbarCollapse && navbarCollapse.classList.contains('show')) {
                    document.querySelector('.navbar-toggler').click();
                }
            }
        };

        const menuElement = menuRef.current;
        if (menuElement) {
            menuElement.addEventListener('focusout', handleFocusOut);
        }

        return () => {
            if (menuElement) {
                menuElement.removeEventListener('focusout', handleFocusOut);
            }
        };
    }, []);

    const handleMobileCloseMenu = () => {
        document.querySelector('.navbar-toggler').click()
        const h1Element = document.querySelector('h1');
        if (h1Element) {
            h1Element.setAttribute('tabindex', '-1');
            h1Element.focus();
        }
        return;
    }

    return <nav id="header" className="main-header navbar navbar-expand-lg bg-lg-light" role="navigation" aria-label="תפריט ראשי">
        <div className="container-fluid" >
            {isMobile || isNarrowViewport ? <><div className="mobile_menu_con d-flex align-items-center"> 
                <button 
                    className="navbar-toggler me-2" 
                    type="button" 
                    data-bs-toggle="collapse" 
                    data-bs-target="#mahutiLinks" 
                    aria-controls="mahutiLinks" 
                    aria-label="תפריט ראשי"
                    aria-describedby="menuDescription"
                    onClick={() => setIsMenuOpen(!isMenuOpen)}
                    onBlur={() => console.log(1, document.activeElement)}
                >
                    <span id="menuDescription" className="visually-hidden">
                        תפריט ראשי
                    </span>                   
                    <span className="navbar-toggler-icon"></span>
                </button>
                <div className="main-logo ms-2">
                    <a href="https://www.mahuti.co.il"><img src="https://www.mahuti.co.il/wp-content/themes/mahuti/images/img-logo-mahuti-header.svg" alt="מהותי, לעמוד הבית"/></a>
                </div>
            </div>
            <CartHeaderButton /></> :
            
            <div className="main-logo me-2">
                <div className="reset_store" onClick={() => {clearAll(dispatch); navigate(PREFIX_PATH + lpPrefix);}}></div>
                <a href="https://www.mahuti.co.il"><img src="https://www.mahuti.co.il/wp-content/themes/mahuti/images/img-logo-mahuti-header.svg" alt="מהותי, לעמוד הבית"/></a>
            </div>}

            <div className="collapse navbar-collapse" id="mahutiLinks" ref={menuRef}>
                <ul className="navbar-nav me-auto mt-3 mt-lg-0 mb-2 mb-lg-0 almoni_tzar_light text-lg-center text-start">

                    <li className="nav-item">
                        <a className="mahutiLink" href="https://www.mahuti.co.il/about/">אודות</a>
                    </li>
                    <li className="nav-item">
                        <a className="mahutiLink" href="https://www.mahuti.co.il/online/">מהותי אונליין</a>
                    </li>
                    <li className="nav-item">
                        <a className="mahutiLink" href="https://www.mahuti.co.il/parents_and_kids-2/">לכל המשפחה</a>
                    </li>
                    <li className="nav-item">
                        <a className="mahutiLink" href="https://www.mahuti.co.il/kids_and_teens_groups/">קבוצות ילדים ונוער</a>
                    </li>
                    <li className="nav-item">
                        <a className="mahutiLink" href="https://www.mahuti.co.il/organizations_and_groups/">ארגונים וקבוצות</a>
                    </li>
                    <li className="nav-item">
                        <a className="mahutiLink" href="https://www.mahuti.co.il/merchav/">מרחב מהותי</a>
                    </li>
                    <li className="nav-item">
                        <a className="mahutiLink" href="https://www.mahuti.co.il/blog/">בלוג</a>
                    </li>
                    <li className={`nav-item align-items-center d-flex ${isMobile ? 'justify-content-start' : 'justify-content-center mx-3'}`}>
                        {isMobile ? <a className="mahutiLink" href="https://www.mahuti.co.il/purchase/" aria-label="צרו קשר">צרו קשר</a> : <a className="mahutiLink envelop" href="https://www.mahuti.co.il/purchase/" aria-label="צרו קשר"></a>}
                    </li>
                </ul>
                <MahutiContrastToggler contrastTogglerRef={contrastTogglerRef} autofocus={!isMobile}/>
                {isMobile && <button className="close_menu_modal" onFocus={handleMobileCloseMenu}></button>}
                {!(isMobile || isNarrowViewport) && <CartHeaderButton />}
            </div>
        </div>
    </nav >
}